import {createContext, useContext, useMemo} from "react";
import {ScheduleReportsListModel} from '../model/ScheduleReportsListModel.mdl';
import {useModuleFactory} from '@injex/react-plugin';

export interface IScheduleReportsListContext {
    model: ScheduleReportsListModel;
}

export interface IScheduleReportsListWithContext {
    children: any,
}

export const ScheduleReportsListContext = createContext<IScheduleReportsListContext>({
    model: null,
})

export function ScheduleReportsListWithContext({children}: IScheduleReportsListWithContext) {

    const model = useModuleFactory<ScheduleReportsListModel>('scheduleReportsListModel');
    const contextValue: IScheduleReportsListContext = useMemo(() => ({model}), [model]);

    return (
        <ScheduleReportsListContext.Provider value={contextValue}>
            {children}
        </ScheduleReportsListContext.Provider>
    )
}

export function useScheduleReportsListContext(): IScheduleReportsListContext {
    return useContext<IScheduleReportsListContext>(ScheduleReportsListContext);
}
